
import { Component, input, signal } from '@angular/core';
import { CommonUtils, StandardAction } from '@infodata-group/inf-commons';
import { TouchAction } from '../touch-action';

@Component({
  selector: 'infl-touch-action',
  standalone: true,
  imports: [],
  templateUrl: './touch-action.component.html',
  styleUrls: ['./touch-action.component.scss', '../touch-action.scss'],
})
export class TouchActionComponent extends TouchAction {
  public override action = input.required<StandardAction>();

  protected black = signal<string>(CommonUtils.color('black'));
}
